// import logo from './logo.svg';
import './App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import NewPage from './components/NewPage';

function App() {
  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <NewPage />
      </main>
      <Footer />
    </div>
  );
}

export default App;
